import { render, staticRenderFns } from "./FilterModalAssistance.vue?vue&type=template&id=b39ac386&"
import script from "./FilterModalAssistance.vue?vue&type=script&lang=js&"
export * from "./FilterModalAssistance.vue?vue&type=script&lang=js&"
import style0 from "./FilterModalAssistance.vue?vue&type=style&index=0&id=b39ac386&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports